import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import RefreshIcon from 'icons/RefreshButton/Refresh';
import { useMsal } from '@azure/msal-react';
import { formatDate, parseDate } from 'helpers/DateFormatter';
import { TestEquipmentForm } from './TestEquipmentForm';
import { testEquipmentFormState } from '../TestEquipment.data';
import { setDataForAddTestEquipment, resetDataForAddTestEquipment, updateDataForAddTestEquipment, PostAddTestEquipmentData } from './TestEquipmentForm.actions';
import { IsAddMandatory } from './mandatoryFieldsForAddEdit';
import { setCurrentView } from '../../Home/Home.actions';
import { NONMO_USER_ROLE } from 'journeys/portal/Home/Home.constants';

const RefreshFormComponent = ({ buttonHandler }) => <RefreshIcon buttonHandler={buttonHandler} rotate={-90} tooltip="Reset Form" />;
RefreshFormComponent.propTypes = {
    buttonHandler: PropTypes.func.isRequired
};
export const getTestEquipDesc = (data) => {
    if (!data) {
        return '';
    }
    return `${data.TestEqManufacturer} ,${data.TestEqModel}, ${data.TestEqSn
        }, ${parseDate(new Date(data.CalDueDate).toLocaleDateString('en-US'))}`;
};
const AddTestEquipmentForm = (props) => {
    const { setCurrentAppView, resetData, updateFormData, addTestEquipmentData,
        setInitialData, postAddTestEquipmentData, bpRegionNameAlias,
        selectedAssetAliasName, IsLateEntry } = props;
    const FooterButtonVisible = IsAddMandatory(addTestEquipmentData);
    const [disableAddTESubmit, setDisableAddTESubmit] = useState(false);
    const { instance } = useMsal();
    const userName = instance.getActiveAccount();
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);

    useEffect(() => {
        setInitialData(testEquipmentFormState(selectedAssetAliasName, bpRegionNameAlias));
        return () => resetData(testEquipmentFormState(selectedAssetAliasName, bpRegionNameAlias));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAssetAliasName]);
    const UpdateFormDataHandler = (obj) => {
        const objWithPropertiesToBeUpdated = obj;
        objWithPropertiesToBeUpdated.CreatedBy = userName?.name;
        objWithPropertiesToBeUpdated.CreatedDate = formatDate(new Date());
        updateFormData(objWithPropertiesToBeUpdated);
    };

    const SubmitButtonHandler = async () => {
        setDisableAddTESubmit(true);
        const newFormedObject = {
            FullEqDesc: addTestEquipmentData.FullEqDesc || getTestEquipDesc(addTestEquipmentData),
            ModifiedBy: userName?.name,
            LastModifiedDate: formatDate(new Date()),
            IsNonMoTrf: isNonMoFeatureEnabled,
            IsLateEntry
        };
        await postAddTestEquipmentData({ ...addTestEquipmentData, ...newFormedObject });
        setCurrentAppView('testequipment');
    };
    const headerText = () => {
        if (IsLateEntry) {
            return `Add New ${NONMO_USER_ROLE.LateEntryUser} Test Equipment`;
        }
        if (isNonMoFeatureEnabled) {
            return `Add New ${NONMO_USER_ROLE.User} Test Equipment`;
        }
        return 'Add New Test Equipment';
    };
    return (
        <SiteWrapper
            headerText={headerText()}
            ButtonSection={<RefreshFormComponent buttonHandler={() => resetData(testEquipmentFormState(selectedAssetAliasName, bpRegionNameAlias))} />}
            footerButtonHandler={SubmitButtonHandler}
            footerButtonText="Submit"
            FooterButtonVisible={FooterButtonVisible}
            goBack="testequipment"
            isDisabled={disableAddTESubmit}
            displayUnsavedChangesPopUp
        >
            {addTestEquipmentData
                ? (
                    <TestEquipmentForm
                        formId="AddTestEquipmentForm"
                        formValues={addTestEquipmentData}
                        formHandler={(obj) => UpdateFormDataHandler(obj)}
                        bpRegionNameAlias={bpRegionNameAlias}
                        selectedAssetAliasName={selectedAssetAliasName}
                    />
                )
                : null}
        </SiteWrapper>
    );
};

const mapStateToProps = ({ AppData, TestEquipment, Home }) => ({
    addTestEquipmentData: TestEquipment.addTestEquipmentData,
    trfMasterList: Home.trfMasterList,
    assetNameList: Home.assetNameList,
    isMRATOnline: AppData.isMRATOnline,
    selectedAssetAliasName: Home.selectedAssetAliasName,
    bpRegionNameAlias: Home.bpRegionNameAlias,
    IsLateEntry: Home.IsLateEntry
});
const mapDispatchToProps = dispatch => ({
    dispatch,
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    setInitialData: (initialState) => dispatch(setDataForAddTestEquipment(initialState)),
    resetData: (initialState) => {
        dispatch(resetDataForAddTestEquipment(initialState));
    },
    updateFormData: (obj) => {
        dispatch(updateDataForAddTestEquipment(obj));
    },
    postAddTestEquipmentData: (obj) => dispatch(PostAddTestEquipmentData(obj)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddTestEquipmentForm);

AddTestEquipmentForm.propTypes = {
    addTestEquipmentData: PropTypes.object.isRequired,
    bpRegionNameAlias: PropTypes.string,
    IsLateEntry: PropTypes.bool,
    postAddTestEquipmentData: PropTypes.func.isRequired,
    resetData: PropTypes.func,
    selectedAssetAliasName: PropTypes.string,
    setCurrentAppView: PropTypes.func,
    setInitialData: PropTypes.func,
    updateFormData: PropTypes.func,
};
